import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import huntResultsData from '../../../../lib/api/huntResultsData'
import { huntTypesFetchRequest } from '../../../../action/hunt-types-actions'
import { speciesFetchRequest } from '../../../../action/species-actions'
import { weaponTypesFetchRequest } from '../../../../action/weapon-types-actions'
import HarvestDataView from './harvest-data-view'
import SeasonDataView from './season-data-view'
import { PieChart } from '../../common/charts'
import superagent from 'superagent'

class HuntModal extends React.Component {
  constructor(props) {
    super(props)
    //dataview: seasonDates/harvestData
    this.state = {
      dataView: 'seasonDates',
      unitLandUse: null,
      unitData: null
    }
    this.imageFetcher = this.imageFetcher.bind(this)
  }

  componentDidMount() {
    if (this.props.species.length === 0) this.props.speciesFetchRequest()
    if (this.props.huntTypes.length === 0) this.props.huntTypesFetchRequest()
    if (this.props.weaponTypes.length === 0) this.props.weaponTypesFetchRequest()

    //get land use
    const { token, positionedModal } = this.props,
      { properties, layerInfo } = positionedModal.data,
      { getLandUse, getHuntData } = huntResultsData

    this.fetchUnitImage()
    getHuntData(layerInfo.id, properties.unit, token)
      .then(res => {
        this.setState({ unitData: res })
      })
      .catch(err => {
        console.error('Hunt Modal Data Fetch Failed', err)
      })

    getLandUse(layerInfo.id, properties.unit, token)
      .then(res => {
        this.setState({ unitLandUse: res })
      })
      .catch(err => {
        console.error('Hunt Modal Land Use Fetch Failed', err)
      })
  }

  imageFetcher(div, id) {
    const { mapReference, token } = this.props,
      { data } = this.props.positionedModal,
      { properties } = data,
      { bbox, unit } = properties,
      xDiff = Math.abs(bbox[0] - bbox[2]),
      yDiff = Math.abs(bbox[1] - bbox[3]),
      scaler = Math.max(xDiff, yDiff) / Math.min(xDiff, yDiff),
      fetcher = new XMLHttpRequest(),
      width = xDiff < yDiff ? 125 : Math.floor(125 * scaler),
      height = xDiff > yDiff ? 125 : Math.floor(125 * scaler),
      baseSize = Math.floor(125 * scaler)
    let url = `${__API_URI_3__}/layer/render/${id}?bbox=${bbox}&width=${width}&height=${height}&projection=4326${id == 13 ? '' : `&units=${[unit]}`}`
    if (id === 13) {
      url = `https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/export?bbox=${bbox.join('%2C')}&bboxSR=4326&layers=&layerDefs=&size=${baseSize}%2C${baseSize}&imageSR=4326&format=png&transparent=false&dpi=&time=&layerTimeOptions=&dynamicLayers=&gdbVersion=&mapScale=&rotation=&datumTransformations=&layerParameterValues=&mapRangeValues=&layerRangeValues=&f=image`
      div.style.backgroundImage = `url(${url})`
      return
    }
    fetcher.open('GET', url)
    fetcher.setRequestHeader('Authorization', `Bearer ${token}`)
    fetcher.setRequestHeader('content-type', 'image/png')
    fetcher.responseType = 'arraybuffer'
    fetcher.onload = function (e) {
      const blob = new Blob([fetcher.response], {
        type: 'image/png'
      })
      div.style.backgroundImage = `url(${URL.createObjectURL(blob)}`
    }
    fetcher.send()
  }

  fetchUnitImage() {
    const baseImg = document.createElement('div'),
      img = document.createElement('div'),
      { layerInfo } = this.props.positionedModal.data

    baseImg.classList.add('hunt-modal-image')
    img.classList.add('hunt-modal-image')
    document.getElementById('hunt-unit-image').appendChild(baseImg)
    document.getElementById('hunt-unit-image').appendChild(img)

    this.imageFetcher(baseImg, 13)
    this.imageFetcher(img, layerInfo.id)
  }

  makeSeasonDataViews() {
    const { unitData } = this.state
    return (
      <div>
        <div>
          seasonboxes
        </div>
        <div>
          buttons
        </div>
      </div>
    )
  }

  render() {
    const { positionedModal, species } = this.props,
      { dataView, unitLandUse, unitData } = this.state,
      { data } = positionedModal,
      { properties, layerInfo } = data,
      speciesInfo = species.find(entry => entry.id === layerInfo.speciesId),
      pieChartPalette = ['#d14c00', '#7f554d', '#c48074', '#dbc2db']
    return (
      <div className='hunt-modal-outer-container center'
        onClick={(e) => { e.stopPropagation() }}>
        <div className='hunt-modal-top-matter'>
          <div className='hunt-modal-unit-image' id='hunt-unit-image'></div>
          <div className='hunt-modal-top-details'>
            <div className='hunt-modal-title'>
              <span>{`UNIT ${properties.unit}`}</span>
            </div>
            <div className='hunt-modal-top-detail-row'>
              <p className='hunt-modal-top-detail-name'>SPECIES:</p>
              <p className='hunt-modal-top-detail-entry'>{speciesInfo.name}</p>
            </div>
            <div className='hunt-modal-top-detail-row'>
              <p className='hunt-modal-top-detail-name'>STATE:</p>
              <p className='hunt-modal-top-detail-entry'>{unitLandUse ? unitLandUse.state : ''}</p>
            </div>
            <div className='hunt-modal-top-detail-row'>
              <p className='hunt-modal-top-detail-name'>UNIT:</p>
              <p className='hunt-modal-top-detail-entry'>{properties.unit}</p>
            </div>
            <div className='hunt-modal-top-detail-row'>
              <p className='hunt-modal-top-detail-name'>ACRES:</p>
              <p className='hunt-modal-top-detail-entry'>{unitLandUse ? unitLandUse.totalAcres : ''}</p>
            </div>
          </div>
          <div className='hunt-modal-pie-chart'>
            {
              this.state.unitLandUse && this.state.unitLandUse.huntOwnershipValues ?
                <PieChart colors={pieChartPalette}
                  data={this.state.unitLandUse.huntOwnershipValues}
                  valKey='value'
                  nameKey='name' /> : null
            }
          </div>
        </div>
        <div className='hunt-modal-data-container'>
          <div className='hunt-modal-buttons-container'>
            <button className='hunt-modal-mode-button'
              onClick={() => { this.setState({ dataView: 'seasonDates' }) }}
              style={{
                backgroundColor: dataView === 'seasonDates' ? '#808080' : '#4f4f4f'
              }}>SEASON DATES</button>
            <button className='hunt-modal-mode-button'
              onClick={() => { this.setState({ dataView: 'harvestData' }) }}
              style={{
                backgroundColor: dataView === 'harvestData' ? '#808080' : '#4f4f4f'
              }}>HARVEST DATA</button>
          </div>
          <div className='hunt-data-content'>
            {dataView === 'seasonDates' && unitData ? <SeasonDataView unitData={unitData} /> : null}
            {dataView === 'harvestData' && unitData ? <HarvestDataView unitData={unitData} /> : null}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  mapReference: state.mapReference(),
  token: state.auth.token,
  species: state.species,
  huntTypes: state.huntTypes,
  weaponTypes: state.weaponTypes,
  positionedModal: state.positionedModal
})

const mapDispatchToProps = dispatch => ({
  speciesFetchRequest: () => dispatch(speciesFetchRequest()),
  huntTypesFetchRequest: () => dispatch(huntTypesFetchRequest()),
  weaponTypesFetchRequest: () => dispatch(weaponTypesFetchRequest()),
})

export default connect(mapStateToProps, mapDispatchToProps)(HuntModal)